var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.viewingProfile)?_c('tab-content',[_c('profile-viewer',{attrs:{"id":_vm.viewingProfile,"offer-id":_vm.viewingProfileOfferId}})],1):_c('router-view'),(_vm.makeOfferDialog)?_c('make-offer-dialog',{attrs:{"profile":_vm.offeringProfile,"gigId":_vm.gigId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }